export const LIBRARY_SOURCE_KEY = "x-library-source";

export const DEFAULT_HEADERS = {
  [LIBRARY_SOURCE_KEY]: "brytdesigns-shopify-ajax-cart",
} as const;
